<template>
  <div>
    <b-modal
      id="mantenimientoForm"
      title="REPARACION Y MANTENIMIENTO"
      size="xl"
      scrollable
      hide-footer
      no-close-on-esc
      @shown="onModalShown"
    >
      <div class="card">
        <div class="card-body">
          <div class="container-fluid h-100">
            <div class="row h-100">
              <form
                v-promise-btn="{ action: 'submit' }"
                @submit.prevent="validarForm"
              >
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-md-6 form-group form-group-md">
                      <div class="form-group">
                        <label for="nombre_cliente" class="label"
                          >Nombre de cliente/id</label
                        >
                        <input
                          id="nombre_cliente"
                          v-model="nombreCliente"
                          :class="`form-control form-control-sm  bg-white`"
                          disabled
                          style="cursor: text"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6 form-group form-group-md">
                      <div class="form-group">
                        <label for="avl" class="label">Avl/id</label>
                        <input
                          type="text"
                          class="form-control"
                          disabled
                          name="Avl"
                          id="avl"
                          v-model="avl"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6 form-group form-group-sm">
                      <label class="label" for="instalador">Instalador</label>
                      <SelectInstalador v-model="instalador" />
                    </div>
                    <div class="col-12 col-md-6 form-group form-group-sm">
                      <label for="fecha">Fecha</label>
                      <input
                        id="fecha"
                        type="datetime-local"
                        class="form-control"
                        v-model="fecha_hora_ingreso"
                      />
                    </div>
                    <div class="col-12 form-group form-group-md">
                      <div class="form-group">
                        <label for="chip_nuevo" class="label"
                          >Ubicacion de avl</label
                        >
                        <input
                          type="text"
                          class="form-control text-center"
                          name="chip nuevo"
                          id="chip_nuevo"
                          v-model="ubicacionAvl"
                        />
                      </div>
                    </div>

                    <div class="col-12 form-group form-group-md">
                      <div class="form-group">
                        <label for="comentario_trazabilidad" class="label"
                          >Comentario de trazabilidad</label
                        >
                        <textarea
                          class="form-control text-center"
                          name="comentario de trazabi"
                          id="comentario_trazabilidad"
                          v-model="comentarioTrazabilidad"
                        />
                      </div>
                    </div>

                    <div class="col-12 card">
                      <label>Detalle de Mantenimiento</label>
                      <div class="card-body row">
                        <div class="container">
                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group-md d-flex align-items-center"
                            >
                              <label
                                class="form-check-label"
                                for="checkCostoMantenimiento"
                                style="cursor: pointer"
                              >
                                <input
                                  id="checkCostoMantenimiento"
                                  v-model="checkCostoMantenimiento"
                                  class="form-check-inline"
                                  style="zoom: 1.5; cursor: pointer"
                                  type="checkbox"
                                />
                                Se cobra al cliente
                              </label>
                            </div>

                            <div
                              v-show="!!checkCostoMantenimiento"
                              class="col-12 col-md-6 form-group-md"
                            >
                              <div class="form-group">
                                <label
                                  for="reparacion-mantenimiento"
                                  class="label"
                                  >Costo de reparacion / mantenimiento</label
                                >
                                <input
                                  type="text"
                                  v-select-on-focus
                                  class="form-control"
                                  name="reparacion o mantenimiento"
                                  id="reparacion-mantenimiento"
                                  v-model="costoMantenimiento"
                                />
                              </div>
                            </div>

                            <div
                              v-if="!!checkCostoMantenimiento"
                              class="col-12 form-group-md"
                            >
                              <div class="form-group">
                                <label for="concepto" class="label"
                                  >Concepto</label
                                >
                                <textarea
                                  type="text"
                                  class="form-control"
                                  name="concepto"
                                  id="concepto"
                                  v-model="concepto"
                                />
                                <small
                                  >si se cobra poner concepto y detalle. Esto le
                                  FIGURA en el mail AL CLIENTE.</small
                                >
                              </div>
                            </div>
                            <div
                              v-if="!!checkCostoMantenimiento"
                              class="col-12 form-group-md"
                            >
                              <div class="form-group">
                                <label for="detalle" class="label"
                                  >Detalle</label
                                >
                                <textarea
                                  id="detalle"
                                  v-model="detalle"
                                  :class="`form-control form-control-sm  bg-white`"
                                  style="cursor: text"
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-md d-flex align-items-center"
                            >
                              <label
                                class="form-check-label"
                                for="checkChipNuevo"
                                style="cursor: pointer"
                              >
                                <input
                                  id="checkChipNuevo"
                                  v-model="checkChipNuevo"
                                  class="form-check-inline"
                                  style="zoom: 1.5; cursor: pointer"
                                  type="checkbox"
                                />
                                Se agregó chip nuevo
                              </label>
                            </div>
                            <div
                              v-if="!!checkChipNuevo"
                              class="col-12 col-md-6 form-group form-group-md"
                            >
                              <div class="form-group">
                                <label for="chip_nuevo" class="label"
                                  >Chip nuevo</label
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="chip nuevo"
                                  id="chip_nuevo"
                                  v-model="chipNuevo"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-md d-flex align-items-center"
                            >
                              <label
                                class="form-check-label"
                                for="checkBateriaNueva"
                                style="cursor: pointer"
                              >
                                <input
                                  id="checkBateriaNueva"
                                  v-model="checkBateriaNueva"
                                  class="form-check-inline"
                                  style="zoom: 1.5; cursor: pointer"
                                  type="checkbox"
                                />
                                Se agregó bateria nueva
                              </label>
                            </div>
                            <div
                              v-if="checkBateriaNueva"
                              class="col-12 col-md-6 form-group form-group-md"
                            >
                              <div class="form-group">
                                <label for="bateria_nueva" class="label"
                                  >Bateria nueva</label
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  name="bateria nueva"
                                  id="bateria_nueva"
                                  v-model="bateriaNueva"
                                />
                                <small
                                  >Dejar valor vacío en este campo a menos que
                                  se cambie la batería interna por un modelo
                                  especial, en cuyo caso va el modelo de la
                                  batería (BL4B - BL5B)</small
                                >
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12 form-group form-group-md d-flex align-items-center"
                            >
                              <label
                                class="form-check-label"
                                for="instalacionEnTaller"
                                style="cursor: pointer"
                              >
                                <input
                                  id="instalacionEnTaller"
                                  v-model="taller"
                                  class="form-check-inline"
                                  style="zoom: 1.5; cursor: pointer"
                                  type="checkbox"
                                />
                                Instalación en Taller
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ViaticosForm v-model="viaticos" ref="viaticosForm" />
                  </div>
                </div>
                <div class="w-100 d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="$bvModal.hide('mantenimientoForm')"
                  >
                    Cancelar
                  </button>
                  <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="ReparacionMantenimientoCaptchaModal"
      size="md"
      title="¡Atención! Verificación Requerida"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="warning"
      header-text-variant="dark"
      body-bg-variant="light"
      header-border-variant="warning"
    >
      <template>
        <div class="d-flex align-items-center w-100"></div>
      </template>

      <div class="captcha-container border-left border-warning pl-3">
        <p class="text-center mb-3 font-weight-bold text-dark">
          <i class="fas fa-shield-alt mr-1"></i>
          Para confirmar el mantenimiento o reparacion de un contrato con un AVL
          que no está reportando, por favor resuelva la siguiente operación:
        </p>

        <MathCaptcha v-model="isCaptchaValid" />

        <div class="alert alert-warning small mt-3">
          <i class="fas fa-info-circle"></i>
          Esta verificación es necesaria para operaciones sensibles que
          involucran dispositivos que no están reportando.
        </div>

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="cancelarCaptcha">
            <i class="fas fa-times mr-1"></i> Cancelar
          </button>
          <button
            class="btn btn-warning text-dark font-weight-bold"
            @click="submit"
          >
            <i class="fas fa-check mr-1"></i> Confirmar reparación o
            mantenimiento
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SelectInstalador from "../../Commons/SelectInstalador.vue";
import NombreCliente from "../../../shared/NombreCliente";
import axios from "axios";
import moment from "moment";
import MathCaptcha from "../../../shared/MathCaptcha.vue";
import ViaticosForm from "../../../../../components/Viaticos/ViaticosForm.vue";

export default {
  name: "mantenimiento-item",
  mixins: [NombreCliente],
  mounted() {
    this.getNombreCliente(this.$route.params.id_cliente);
  },
  data: () => ({
    comentarioTrazabilidad: "",
    costoMantenimiento: 0,
    chipNuevo: "",
    bateriaNueva: "",
    concepto: "",
    detalle: "",
    taller: false,
    instalador: null,
    fecha_hora_ingreso: "",
    checkChipNuevo: 0,
    checkBateriaNueva: 0,
    checkCostoMantenimiento: 0,
    ubicacionAvl: "",
    isCaptchaValid: false,
    mostrarCaptcha: false,
    isDirty: false,
    viaticos: {
      viaticosCliente: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
      viaticosInstalador: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
    },
  }),
  components: {
    SelectInstalador,
    MathCaptcha,
    ViaticosForm,
  },
  methods: {
    async ObtenerTiempoReporteYEstado() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetTiempoUltimoReporteYEstadoAVL",
          parameters: [{ name: "id_avl", value: this.idAvl }],
        });

        if (resp.data.ok) {
          if (resp.data.result[0][0].esta_reportando === 0) {
            const dataMinutos =
              resp.data.result[0][0].minutos_desde_ultimo_reporte;
            let tiempoReporte = "";
            if (dataMinutos > 60) {
              const horasUltimoReporte = Math.floor(dataMinutos / 60);
              const minutosDeHorasUltimoReporte = Math.floor(dataMinutos % 60);

              tiempoReporte = `${horasUltimoReporte} horas y ${minutosDeHorasUltimoReporte} minutos`;
            } else {
              tiempoReporte = `${dataMinutos} minutos`;
            }

            try {
              const mensaje = this.$createElement("div", [
                this.$createElement(
                  "p",
                  "¡Ojo! Señal de satélites desactualizada!",
                ),
                this.$createElement(
                  "p",
                  `El último reporte con señal satelital fue hace ${tiempoReporte}`,
                ),
                this.$createElement("p", "¿Está seguro que desea continuar?"),
              ]);

              const respuestaMensaje = await this.$bvModal.msgBoxConfirm(
                mensaje,
                {
                  title: "Advertencia",
                  size: "md",
                  buttonSize: "sm",
                  okVariant: "danger",
                  okTitle: "Sí, continuar",
                  cancelVariant: "secondary",
                  cancelTitle: "No, cancelar",
                  footerClass: "p-2",
                  hideHeaderClose: false,
                  centered: true,
                  headerBgVariant: "warning",
                  headerTextVariant: "dark",
                },
              );
              if (respuestaMensaje) {
                this.mostrarCaptcha = true;
                this.$bvModal.show("ReparacionMantenimientoCaptchaModal");
              } else {
                this.mostrarCaptcha = false;
              }
            } catch (modalError) {
              this.mostrarCaptcha = false;
              this.$msgBoxOk("Error en la confirmación de cambio de vehículo", {
                title: "Error",
              });
            }
          } else {
            await this.submit();
          }
        } else {
          await this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        this.$msgBoxOk("Error al verificar el estado del AVL: " + error);
        this.mostrarCaptcha = false;
      }
    },
    onModalShown() {
      this.fecha_hora_ingreso = this.Fecha_hora_ingreso;
      this.checkCostoMantenimiento = 0;
      this.checkChipNuevo = 0;
      this.checkBateriaNueva = 0;
      this.comentarioTrazabilidad = "";
      this.costoMantenimiento = 0;
      this.chipNuevo = "";
      this.bateriaNueva = "";
      this.concepto = "";
      this.detalle = "";
      this.taller = false;
      this.instalador = null;
      this.ubicacionAvl = this.UbicacionAvl;
      this.isCaptchaValid = false;
      this.isDirty = false;
      this.mostrarCaptcha = false;
      this.viaticos = {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
    },
    cancelarCaptcha() {
      this.$bvModal.hide("ReparacionMantenimientoCaptchaModal");
      this.mostrarCaptcha = false;
      this.isCaptchaValid = false;
    },
    async validarForm() {
      this.isDirty = true;
      if (this.instalador === null) {
        this.$msgBoxOk("Por favor, seleccione un instalador");
        return;
      }
      if (this.ubicacionAvl.trim() === "") {
        this.$msgBoxOk("Por favor, complete el campo de ubicacion de avl");
        return;
      }
      if (this.comentarioTrazabilidad.trim() === "") {
        this.$msgBoxOk("Por favor, complete el campo de trazabilidad");
        return;
      }
      if (this.idAvl === null || this.idAvl === undefined) {
        await this.$msgBoxOk("Ups, algo salio mal. Avl no encontrado");
        return;
      }

      if (this.checkCostoMantenimiento) {
        if (
          this.costoMantenimiento === null ||
          this.costoMantenimiento === "" ||
          isNaN(this.costoMantenimiento) ||
          Number(this.costoMantenimiento) < 0
        ) {
          this.$msgBoxOk(
            "Por favor, ingrese un costo de mantenimiento válido (número mayor o igual a 0).",
          );
          return;
        }
        if (this.concepto.trim() === "") {
          this.$msgBoxOk(
            "Por favor, ingrese un concepto para el costo de mantenimiento.",
          );
          return;
        }
        if (this.detalle.trim() === "") {
          this.$msgBoxOk(
            "Por favor, ingrese un detalle para el costo de mantenimiento.",
          );
          return;
        }
      }
      if (this.$refs.viaticosForm) {
        const viaticosErrors = this.$refs.viaticosForm.validateForm();
        if (viaticosErrors.length > 0) {
          const mensaje = viaticosErrors.map((msj) =>
            this.$createElement("p", msj),
          );
          this.$msgBoxOk(mensaje, {
            title: this.$createElement("h4", "Controlar formulario"),
          });
          return;
        }
      }

      await this.ObtenerTiempoReporteYEstado();
    },
    async submit() {
      if (this.mostrarCaptcha && !this.isCaptchaValid) {
        return;
      }

      if (this.mostrarCaptcha) {
        this.$bvModal.hide("ReparacionMantenimientoCaptchaModal");
      }

      try {
        const viaticosFormateados = this.$refs.viaticosForm
          ? this.$refs.viaticosForm.getFormattedViaticos()
          : this.viaticos;

        const resp = await axios.post("/execute", {
          method: "CLI.MantenimientoOReparacionByContrato",
          parameters: [
            { name: "id_cliente", value: this.$route.params.id_cliente },
            { name: "id_avl", value: this.avl },
            { name: "id_instalador", value: this.instalador.id_instaladores },
            {
              name: "comentario_trazabilidad",
              value: this.comentarioTrazabilidad,
            },
            { name: "id_chip_nuevo", value: this.chipNuevo },
            { name: "costo_cliente", value: this.costoMantenimiento },
            { name: "concepto", value: this.concepto },
            { name: "detalle", value: this.detalle },
            { name: "bateria_nueva", value: this.bateriaNueva },
            { name: "taller", value: this.taller ? 1 : 0 },
            {
              name: "fecha_hora_ingreso",
              value: moment(this.fecha_hora_ingreso).format("YYYY-MM-DD HH:mm"),
            },
            { name: "ubicacion_avl", value: this.ubicacionAvl },
            {
              name: "viaticos_cliente_activo",
              value: viaticosFormateados.viaticosCliente.activo ? 1 : 0,
            },
            {
              name: "viaticos_cliente_combustible_activo",
              value: viaticosFormateados.viaticosCliente.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_combustible_kilometros",
              value: viaticosFormateados.viaticosCliente.combustible.kilometros,
            },
            {
              name: "viaticos_cliente_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosCliente.combustible.montoCalculado,
            },
            {
              name: "viaticos_cliente_combustible_descripcion",
              value:
                viaticosFormateados.viaticosCliente.combustible.descripcion,
            },
            {
              name: "viaticos_cliente_adicional_activo",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_adicional_monto",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.monto,
            },
            {
              name: "viaticos_cliente_adicional_descripcion",
              value:
                viaticosFormateados.viaticosCliente.viaticoAdicional
                  .descripcion,
            },
            {
              name: "viaticos_instalador_activo",
              value: viaticosFormateados.viaticosInstalador.activo ? 1 : 0,
            },
            {
              name: "viaticos_instalador_combustible_activo",
              value: viaticosFormateados.viaticosInstalador.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_combustible_kilometros",
              value:
                viaticosFormateados.viaticosInstalador.combustible.kilometros,
            },
            {
              name: "viaticos_instalador_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosInstalador.combustible
                  .montoCalculado,
            },
            {
              name: "viaticos_instalador_combustible_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.combustible.descripcion,
            },
            {
              name: "viaticos_instalador_adicional_activo",
              value: viaticosFormateados.viaticosInstalador.viaticoAdicional
                .activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_adicional_monto",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional.monto,
            },
            {
              name: "viaticos_instalador_adicional_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional
                  .descripcion,
            },
          ],
        });
        let mjeExito = `Reparación o mantenimiento del cliente ${this.nombreCliente} cargado con éxito`;
        if (resp.data.ok) {
          await this.$msgBoxOk(mjeExito).then(() => {
            this.$emit("update");
            this.$bvModal.hide("mantenimientoForm");
          });
        } else {
          this.$msgBoxOk(resp.data.message);
          this.ubicacionAvl = this.UbicacionAvl;
        }
        return resp.data;
      } catch (error) {
        this.$msgBoxOk("Error al realizar la operación: " + error);
        this.ubicacionAvl = this.UbicacionAvl;
      }
    },
  },
  computed: {
    avl: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.avl;
      },
    },
    Fecha_hora_ingreso: {
      get() {
        return moment().format("YYYY-MM-DD HH:mm");
      },
    },
    UbicacionAvl: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.ubicacionAvl;
      },
      set(value) {
        this.$store.commit(
          "Contratos/ModificarContrato/setUbicacionAvl",
          value,
        );
      },
    },
    idAvl: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.avl;
      },
    },
  },
  watch: {
    checkCostoMantenimiento(newVal) {
      if (!newVal) {
        this.costoMantenimiento = 0;
        this.concepto = "";
        this.detalle = "";
      }
    },
  },
};
</script>
<style scoped>
.captcha-container {
  padding: 1rem;
}
</style>
